var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "", "align-center": "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", md6: "", lg3: "" } },
        [
          _c("v-select", {
            attrs: { items: _vm.avls, label: "AVL" },
            model: {
              value: _vm.avl,
              callback: function($$v) {
                _vm.avl = $$v
              },
              expression: "avl"
            }
          })
        ],
        1
      ),
      _vm.avl
        ? _c(
            "v-flex",
            { attrs: { xs12: "", md6: "", lg3: "" } },
            [
              _c("FlotaFilterAutocomplete", {
                attrs: { avl: _vm.avl },
                model: {
                  value: _vm.flota,
                  callback: function($$v) {
                    _vm.flota = $$v
                  },
                  expression: "flota"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-flex",
        { attrs: { xs12: "", md6: "", lg3: "" } },
        [
          _c("v-text-field", {
            attrs: { label: "Patente" },
            model: {
              value: _vm.patente,
              callback: function($$v) {
                _vm.patente = $$v
              },
              expression: "patente"
            }
          })
        ],
        1
      ),
      _c("v-flex", { attrs: { xs12: "", md6: "", lg3: "" } }, [
        _c(
          "div",
          { staticClass: "text-sm-center" },
          [
            _c(
              "v-btn",
              {
                attrs: { flat: "", icon: "", small: "" },
                on: { click: _vm.onChangeFilter }
              },
              [_c("v-icon", [_vm._v("search")])],
              1
            ),
            _c(
              "v-btn",
              {
                attrs: { flat: "", icon: "", small: "" },
                on: { click: _vm.clearFilters }
              },
              [_c("v-icon", [_vm._v("clear")])],
              1
            )
          ],
          1
        )
      ]),
      _vm.flota.nombre !== ""
        ? _c(
            "v-flex",
            { attrs: { xs12: "", md6: "", lg3: "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        xs12: "",
                        md6: "",
                        "offset-lg6": "",
                        "offset-md6": ""
                      }
                    },
                    [_c("AsignacionDialog", { attrs: { flota: _vm.flota } })],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }